






























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import { InvoiceCreateUseCase } from '@/modules/invoice/use-cases/admin/invoice-create.use-case'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminInvoiceForm from '@/modules/invoice/components/admin/AdminInvoiceForm.vue'
import AdminInvoiceItemForm from '@/modules/invoice-item/components/admin/AdminInvoiceItemForm.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import { InvoiceResourceTypeInAdmin } from '@/modules/invoice/models/invoice-reource.model'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'ایجاد فاکتور'
  },
  metaInfo: {
    title: 'ایجاد فاکتور'
  },
  components: { BaseCard, BaseInput, AdminInvoiceItemForm, AdminInvoiceForm, BaseButton, PriceView, Toggle }
})
export default class CreatePage extends Vue {
  constructor(
    private readonly invoiceCreateUseCase: InvoiceCreateUseCase
  ) {
    super()
  }

  @Prop() invoiceData!: InvoiceResourceTypeInAdmin
  invoice: InvoiceResourceTypeInAdmin = this.initData()
  notifyToUser = false

  onSubmit() {
    this.invoiceCreateUseCase.execute(this.invoice.data, this.notifyToUser)
  }

  initData() {
    this.$set(this.invoiceData, 'data', { items: [], user: {} })
    return this.invoiceData
  }

}
